export default {
    namespaced: true,
    state:{
      currentItem: null,
      currentSubItem: null,
    },
    mutations:{
      setCurrentItem: (state, currentItem) => state.currentItem = currentItem,
      setCurrentSubItem: (state, currentSubItem) => state.currentSubItem = currentSubItem
    },
    getters:{
      getCurrentItem: state => state.currentItem,
      getCurrentSubItem: state => state.currentSubItem
    }
}